<template>
  <div class="splashscreen">
    <div class="splashscreen-wrapper">
      <span class="splashscreen-text">
        Trwa ładowanie danych&hellip;
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'splashscreen',
  mounted () {
    this.$http.post('/auth/me').then(() => {
      let nextRoute = this.$route.params.nextRoute;

      if (!nextRoute || nextRoute === '/wczytywanie') {
        nextRoute = '/';
      }

      setTimeout(() => {
        this.$router.push(nextRoute);
      }, 1000);
    }).catch(error => {
      console.log(error);

      setTimeout(() => {
        this.$router.push({ name: 'Logowanie' });
      }, 1000);
    });
  }
}
</script>
